/* ==========================================================================
   Standard Practice — Enquire instead of Buy
   Injects an "Enquire" button (product page) / link (collection cards) and
   drives the modal that's rendered directly in theme.liquid using Shopify's
   real {% form 'contact' %} (id "sp-contact-form"). The form is submitted
   normally (full page reload) so Shopify's own spam protection — which can
   render a visible captcha challenge — always has a real, visible form to
   attach to. On reload, Shopify prints a success/error message inside the
   form via form.posted_successfully? / form.errors, and we reopen the
   modal automatically to show it.

   The Enquire button is anchored to whichever product-page element exists
   (some products have already had the standard buy-buttons block removed
   in favour of a manual "Price on request" note) — it falls back through
   a few anchor points rather than requiring one specific block.

   EXCEPTIONS: product handles listed in KEEP_PRICE_HANDLES keep their
   normal price + native buy flow. Add more handles to the array as needed.
   ========================================================================== */
(function () {
  var KEEP_PRICE_HANDLES = ['standard-tray'];

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function openModal(productTitle, variantSummary) {
    var overlay = document.getElementById('sp-enquire-overlay');
    if (!overlay) return;

    var productEl = document.getElementById('sp-enquire-product');
    if (productEl) productEl.textContent = productTitle || '';

    var form = document.getElementById('sp-contact-form');
    if (form) {
      form.dataset.product = productTitle || '';
      form.dataset.variant = variantSummary || '';
    }

    // Left empty (no pre-fill) so the placeholder guides the visitor.
    // Whatever was selected on the page is still captured separately via
    // form.dataset.variant and included in the emailed enquiry regardless
    // of what — if anything — they type in this field.
    var sizeInput = document.getElementById('sp-size');
    if (sizeInput) sizeInput.value = '';

    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var nameInput = document.getElementById('sp-name');
    if (nameInput) nameInput.focus();
  }

  function closeModal() {
    var overlay = document.getElementById('sp-enquire-overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Fills the hidden contact[body] field right before the browser submits.
  // Deliberately does NOT call preventDefault — the browser (and Shopify's
  // own spam-protection script, if it needs to) handles the real submit.
  function composeBody(e) {
    var form = e.target;
    var companyEl = document.getElementById('sp-company');
    var specsEl = document.getElementById('sp-size');
    var quantityEl = document.getElementById('sp-quantity');
    var bodyEl = document.getElementById('sp-real-body');

    var company = companyEl ? companyEl.value : '';
    var specs = specsEl ? specsEl.value : '';
    var quantity = quantityEl ? quantityEl.value : '';
    var product = form.dataset.product || '';
    var variant = form.dataset.variant || '';

    var lines = [
      'Product enquiry from shop.standardpractice.co',
      '',
      'Product: ' + product,
      variant ? 'Selected option: ' + variant : '',
      'Custom specs: ' + specs,
      'Quantity: ' + quantity,
      company ? 'Company: ' + company : '',
      '',
      'Page: ' + window.location.href
    ].filter(Boolean).join('\n');

    if (bodyEl) bodyEl.value = lines;

    var submitBtn = form.querySelector('.sp-enquire-submit');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Sending…';
    }
  }

  function getVariantSummary() {
    var selects = document.querySelectorAll('variant-selects select');
    var parts = [];
    selects.forEach(function (s) { parts.push(s.value); });
    return parts.join(' / ');
  }

  function initModalChrome() {
    var overlay = document.getElementById('sp-enquire-overlay');
    if (!overlay) return;

    var closeBtn = document.getElementById('sp-enquire-close');
    var form = document.getElementById('sp-contact-form');

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
    if (form) form.addEventListener('submit', composeBody);

    // If Shopify just rendered a result (success/error) on this load,
    // reopen the modal so the visitor sees it instead of missing it.
    if (overlay.querySelector('.sp-enquire-result')) {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  // Finds the best place to put the Enquire button on a product page.
  // Prefers the standard buy-buttons block, but falls back to sitting
  // right after the variant pickers, or after the title, so products
  // that have had their buy block manually removed still get a button.
  function getButtonAnchor(container) {
    var buttonsWrap = container.querySelector('.product-form__buttons');
    if (buttonsWrap) return { el: buttonsWrap, mode: 'prepend' };

    var variantSelects = container.querySelector('variant-selects');
    if (variantSelects) return { el: variantSelects, mode: 'after' };

    var titleEl = container.querySelector('.product__title');
    if (titleEl) return { el: titleEl, mode: 'after' };

    return { el: container, mode: 'append' };
  }

  function initProductPage() {
    // Excluded product (e.g. Standard Tray): body carries "sp-keep-price"
    // (added via a small theme.liquid conditional) — leave native buy flow alone.
    if (document.body.classList.contains('sp-keep-price')) return;

    var container = document.querySelector('#MainContent product-info');
    if (!container) return;

    var titleEl = container.querySelector('h1');
    var title = titleEl ? titleEl.textContent.trim() : document.title;

    var anchor = getButtonAnchor(container);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sp-enquire-btn';
    btn.textContent = 'Enquire';

    if (anchor.mode === 'prepend') {
      anchor.el.insertBefore(btn, anchor.el.firstChild);
    } else if (anchor.mode === 'after') {
      anchor.el.insertAdjacentElement('afterend', btn);
    } else {
      anchor.el.appendChild(btn);
    }

    function launch() {
      openModal(title, getVariantSummary());
    }

    btn.addEventListener('click', launch);

    // Auto-open if arriving from a collection-card "Enquire" link (#enquire),
    // but not if we're already showing a submitted result.
    if (window.location.hash === '#enquire' && !document.querySelector('.sp-enquire-result')) {
      launch();
    }
  }

  function initCollectionCards() {
    document.querySelectorAll('.card-wrapper.product-card-wrapper').forEach(function (card) {
      var priceEl = card.querySelector('.price');
      var link = card.querySelector('a.full-unstyled-link');
      if (!priceEl || !link) return;

      var href = link.getAttribute('href') || '';
      var isKept = KEEP_PRICE_HANDLES.some(function (handle) {
        return href.indexOf('/products/' + handle) !== -1;
      });

      if (isKept) {
        priceEl.classList.add('sp-show-price');
        return; // leave this card's price visible, no Enquire link
      }

      var enquireLink = document.createElement('a');
      enquireLink.href = href + '#enquire';
      enquireLink.className = 'sp-enquire-card-link';
      enquireLink.textContent = 'Enquire';
      priceEl.insertAdjacentElement('afterend', enquireLink);
    });
  }

  ready(function () {
    initModalChrome();
    initProductPage();
    initCollectionCards();
  });
})();
